module.exports = __webpack_public_path__ + "static/media/add_reaction.b90a65f2.svg";